module.exports = __webpack_public_path__ + "img/personnage_choix_4.f3cec7eb.png";